import React, { useEffect, useContext } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { MyContext } from '../context/UserProvider';
import { useNavigate } from 'react-router-dom';

const AnimatedInput = () => {
    const controls = useAnimation();
    const { showAnimatedInput } = useContext(MyContext);
    const navigate = useNavigate();

    useEffect(() => {
        const topOn = -15;
        const topOff = 0;
        const fontSizeOn = 10;
        const fontSizeOff = 15;

        controls.start({
            top: `${showAnimatedInput ? topOn : topOff}px`,
            fontSize: `${showAnimatedInput ? fontSizeOn : fontSizeOff}px`,
            color: showAnimatedInput ? '#000' : 'rgba(128, 125, 119, 0.9)',
            letterSpacing: showAnimatedInput ? '0px' : '8px',  // Remover o espaçamento no final da animação
            transition: { duration: 0.6, ease: 'easeInOut' }
        });
    }, [showAnimatedInput, controls]);

    return (
        <motion.div  translate="no" style={{ position: 'relative', width: '100%' }}>
            <motion.h1
                animate={controls}
                initial={{ top: '-40px', fontSize: '15px', color: 'rgba(128, 125, 119, 0.9)' }}
                style={{
                    position: 'absolute',
                    left: '2px',
                    transform: 'translateY(-50%)',
                    fontFamily: 'Playfair Display',
                    margin: 0,
                    whiteSpace: 'nowrap',
                    fontWeight: 'normal',
                    cursor: 'pointer',
                    pointerEvents: 'none',
                }}
                onClick={() => navigate('/')}
            >
                O que procura?
            </motion.h1>
        </motion.div>
    );
};

export default AnimatedInput;
